import Sidebar from './sidebar';
import { useState } from 'react';

function NewIekSidebarFixed() {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div>
            <div className="ui-button product-catalog-button" onClick={() => setIsOpen(true)}>
                Каталог продукции
            </div>
            <div
                className={'product-catalog' + (isOpen ? ' product-catalog--fixed' : '')}
                onClick={() => setIsOpen(false)}
            >
                <div className="product-catalog-close" onClick={() => setIsOpen(false)} />
                <Sidebar />
            </div>
        </div>
    );
}

export default NewIekSidebarFixed;
